module.exports = __webpack_public_path__ + "static/v1.b-57ae846097d34caa6692ce19e615b7c0.jpg";